import {
  useAudioPlayerQueue,
  useAudioPlayerState,
} from "@/components/providers/AudioPlayerProvider/useAudioPlayer";
import EmptyPlayer from "./EmptyPlayer";
import PlayerBar from "./PlayerBar";

export default function AudioPlayer() {
  const { currentTrack } = useAudioPlayerState();
  const { queue, hydrated, restoredFromStorage } = useAudioPlayerQueue();

  if (!currentTrack) {
    if (hydrated && queue.length === 0 && restoredFromStorage) {
      return <EmptyPlayer />;
    }
    return null;
  }

  return <PlayerBar />;
}
